import type BundlingStore from "./schema/BundlingStore";
import { createStore } from "owa-satcheljs";
const initialBundlingStore: BundlingStore = {
    loadedImports: new Map<string, boolean>(),
};

export const getStore: () => BundlingStore = createStore("bundlingStore", initialBundlingStore);

const _default_1: {
    getStore: () => BundlingStore;
} = {
    getStore,
};
export default _default_1;
